export const PANEL_CLASSES = "bg-white rounded-lg border border-ui-divider-lines overflow-hidden flex flex-col";

export const HEADER_CLASSES = "px-3.5 py-2.5 font-semibold text-sm text-ui-text-primary-text border-b border-ui-divider-lines bg-unlisted-very-light-gray flex justify-between items-center";

export const SECTION_LABEL = "text-[12px] font-bold text-ui-text-primary-text uppercase tracking-wide mb-2";

const MAPPING_DISPLAY_BASE = "rounded-md px-2.5 py-1 font-mono text-xs flex items-center gap-1.5 flex-1 min-h-[28px] border";

// Valid mapping (path found in schema): subtle — dark-gray border + black text, no fill — to reduce color noise.
export const MAPPING_DISPLAY = `${MAPPING_DISPLAY_BASE} border-unlisted-secondary-gray text-ui-text-primary-text`;

// Invalid mapping (path not in schema): kept prominent with a yellow fill so it stands out as a warning.
export const MAPPING_DISPLAY_WARNING = `${MAPPING_DISPLAY_BASE} bg-unlisted-warning-yellow border-unlisted-warning-yellow text-yellow-1`;

export const DROP_ZONE = "flex-1 border-2 border-dashed rounded-md px-3 py-1.5 min-h-[28px] text-xs text-center transition-all";

export const DROP_ZONE_ACTIVE = "border-ui-cta-primary bg-teal-t10 text-ui-cta-primary";

export const DROP_ZONE_IDLE = "border-ui-field-outline text-ui-text-primary-text";

// Empty drop zones while a source leaf is armed for click-mapping — signals "click me".
export const DROP_ZONE_TARGET_HOT = "border-ui-cta-primary text-ui-cta-primary animate-pulse cursor-pointer";

export const LOCKED_FIELD = "bg-unlisted-very-light-gray rounded-md px-2.5 py-1 font-mono text-xs text-ui-text-primary-text flex items-center gap-1.5 flex-1 min-h-[28px] border border-ui-field-outline";

// ── Per-field transforms ──
// Purple is the accent for everything transform-related (wand, pills, transformed preview),
// so the feature reads as one distinct system against the green/blue mapping UI.

// Small wand button inside a mapping chip that opens the transform picker.
export const TRANSFORM_ADD_BTN = "text-unlisted-purple hover:text-unlisted-dark-purple leading-none px-1 py-0.5 rounded shrink-0";
export const TRANSFORM_ADD_BTN_ACTIVE = "text-unlisted-dark-purple bg-unlisted-light-purple leading-none px-1 py-0.5 rounded shrink-0";
// Shown (not hidden) when the filter is complex, so the feature stays discoverable —
// paired with a tooltip explaining why it's unavailable.
export const TRANSFORM_ADD_BTN_DISABLED = "text-ui-text-disabled cursor-not-allowed leading-none px-1 py-0.5 rounded shrink-0 inline-flex";

// A single applied-transform pill shown beneath a mapping chip
// (icon + monospace summary + subtle ×).
export const TRANSFORM_PILL = "inline-flex items-center gap-1.5 font-mono text-[11px] bg-unlisted-light-purple text-unlisted-dark-purple rounded-full px-2.5 py-0.5";

// Transformed value shown after the pills (`= 2024-06-26T…`).
export const TRANSFORM_PREVIEW = "text-unlisted-dark-purple text-[11px] max-w-[160px] overflow-hidden text-ellipsis whitespace-nowrap";

// Portaled grouped picker popover.
export const TRANSFORM_MENU = "bg-white border border-ui-divider-lines rounded shadow-lg overflow-hidden py-1";
export const TRANSFORM_MENU_SECTION = "text-[10px] font-bold text-ui-text-primary-text uppercase tracking-wide px-3 pt-2 pb-1";
export const TRANSFORM_MENU_ITEM = "w-full flex items-center justify-between gap-3 px-3 py-1.5 text-xs text-left text-ui-text-primary-text transition-colors focus:outline-none hover:bg-unlisted-light-purple";
